import { GetterTree } from 'vuex'
import {
  ConfigurationPanelState
} from '@/store/modules/configurationPanel/configurationPanelTypes'
import { RootState } from '@/store/types/storeGlobalTypes'

export const getters: GetterTree<ConfigurationPanelState, RootState> = {

}
